import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';

export const getArcgisPassword = async () => {
  const urlBuilder = createUrlBuilder(`/arcgis/password`).toString();

  return await getRequest(AppService, urlBuilder);
};

export const addArcgisPassword = async (replaceExisting: boolean) => {
  const urlBuilder = await createUrlBuilder(
    `/arcgis/password${replaceExisting ? '?replaceExisting=true' : ''}`
  ).toString();

  return await postRequest(AppService, urlBuilder);
};

export const deleteArcgisPassword = async () => {
  const urlBuilder = await createUrlBuilder(`/arcgis/password`).toString();

  return await deleteRequest(AppService, urlBuilder);
};
